import React,{useState, useEffect} from 'react';

import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jbreak(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
  <Sides/>
  <Helmet>
 
 <title>Mastering Java Break Statements: A Beginner's Tutorial | CodeExampler</title>
<meta name="description" content="Learn how to use the Java break statement with CodeExampler's easy-to-follow tutorial for beginners. Discover how to break out of loops and interrupt the flow of your program with examples and explanations." />
<meta name="keywords" content="Java break statement, Java break loop, Java break for loop, Java break line, Java break while loop, difference between break and continue in java,how to break singleton pattern in java " />
<link rel="canonical" href="https://www.codeexampler.com/java-break" />
</Helmet>

<div className='lg:pl-56'>
 
    <h1 className="m-4 mh1">Break Statement in Java</h1>
    <div className="first">
        <a href="/java-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Java Break:</h2>
<p className="mt-4 para">1, Break in java keyword is used to exit from loop and switch<br/>
2, When a break is encountered inside any loop, control automatically passes to the first statement after the loop.<br/>
3, Break in java statement is used to terminate a loop immediately.<br/>
</p>



<h2 className="headings">Break Statement in java Syntax:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-10">Break; </span>          
          {"\n"}
          {"\n"}
    
       
        </code>
      </pre>        
    </div>





<h2 className="headings">Q-Write a Program break loop on first even no in Java for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> class Break_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">i;</span>
    {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">5;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">);</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">%</span>  
        <span className="qwerty-1">2</span>
        <span className="qwerty-8">==</span>
        <span className="qwerty-1">0</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break; </span>

  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  


 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;1 </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a Program for loop break if i=4 in Java Break for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> class Break_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">i;</span>
    {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">1;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">&#60;</span>
  <span className="qwerty-8">=</span>
  <span className="qwerty-1">5;</span>
  <span className="qwerty-4">i</span>
  <span className="qwerty-8">++</span>     
  <span className="qwerty-1">);</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">==</span>
        <span className="qwerty-1">4</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"This is Break"</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break; </span>

  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>


  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Break Complete "</span>        
      <span className="qwerty-1">);</span>
      {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  


 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;This is Break1 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;This is Break2 </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;This is Break3 </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;Break Complete</span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Array in java Break for loop Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> class Break_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"}
  

          
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-1">[]</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-6"> &#123; </span>
      <span className="qwerty-1">1,2,3,4,5,6,7,8,9,10</span>
      <span className="qwerty-6"> &#125; ;</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
  <span className="qwerty-1">(</span>
  <span className="qwerty-2">int </span>
    <span className="qwerty-4">i</span>
  <span className="qwerty-8">:</span>  
  <span className="qwerty-4">arr</span>  
  <span className="qwerty-1">);</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">==</span>
        <span className="qwerty-1">4</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"This is Break On"</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;break; </span>

  {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>


  {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"Break Not Complete "</span>        
      <span className="qwerty-1">);</span>
      {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
 
{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Break Not Complete </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;Break Not Complete </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;Break Not Complete </span>
          {"\n"}
          <span className="qwerty-5">&nbsp;This is Break On 4</span>
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/java-for-loop">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-continue">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jbreak;